import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const HomeContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 2rem;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 1rem;
    min-height: 90vh;
    flex-direction: column;
    justify-content: center;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  width: 100%;
  position: relative;
  z-index: 2;
  padding-right: 50%;

  @media (max-width: 768px) {
    padding-right: 0;
    text-align: center;
    background: rgba(255, 255, 255, 0.9);
    padding: 2rem;
    border-radius: 10px;
    margin-top: 2rem;
    order: 2;
  }
`;

const TextContent = styled.div`
  max-width: 600px;

  @media (max-width: 768px) {
    margin: 0 auto;
  }
`;

const Title = styled(motion.h1)`
  font-size: 3.5rem;
  line-height: 1.2;
  font-family: 'Playfair Display', serif;
  color: #000;
  font-weight: 400;
  margin: 0;
  padding: 0;

  &:first-of-type {
    font-size: 2.8rem;
    margin-bottom: 0.5rem;
  }

  @media (max-width: 1200px) {
    font-size: 3rem;
    &:first-of-type {
      font-size: 2.5rem;
    }
  }

  @media (max-width: 768px) {
    font-size: 2.8rem;
    &:first-of-type {
      font-size: 2.2rem;
    }
  }
`;

const Description = styled(motion.p)`
  font-size: 0.9rem;
  color: #666666;
  margin: 1.5rem 0;
  line-height: 1.6;
  font-weight: 300;
  font-family: 'Poppins', sans-serif;
  white-space: nowrap;

  @media (max-width: 768px) {
    white-space: normal;
    font-size: 1rem;
  }

  a {
    color: #007bff;
    text-decoration: none;
    font-weight: 400;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const ViewButton = styled(motion.button)`
  padding: 1rem 2rem;
  font-size: 0.9rem;
  background: transparent;
  border: 1px solid #000;
  color: #000;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background: #000;
    color: #fff;
  }
`;

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  z-index: 1;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media (max-width: 768px) {
    position: relative;
    width: 100%;
    height: 300px;
    max-width: 90vw;
    margin: 0 auto 1rem;
    order: 1;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

    img {
      object-position: center 28%;
    }
  }
`;

const ProfileImage = styled.img`
  width: 180px;
  height: 180px;
  border-radius: 50%;
  margin-bottom: 1rem;
  display: block;
  object-fit: cover;
  object-position: center 20%;
  box-shadow:
    0 0 0 8px rgba(0,123,255,0.18), /* blue glow */
    0 4px 20px rgba(0,123,255,0.12); /* blue shadow */
`;

const Home = () => {
  return (
    <HomeContainer>
      <BackgroundImage>
        <img 
          src="/images/port images1.jpg"
          srcSet="/images/port images1.jpg 1x, /images/port images1@2x.jpg 2x"
          alt="Portfolio Background"
        />
      </BackgroundImage>
      <Content>
        <TextContent>
          <Title
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
          I am
          </Title>
          <Title
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            a Software Engineer
          </Title>
          <Description
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Turning innovative ideas into elegant solutions through code
          </Description>
          <ViewButton
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.6 }}
            onClick={() => window.open('images/SHLOK FINAL CV.pdf', '_blank')}
          >
            View Resume
            <span>→</span>
          </ViewButton>
        </TextContent>
      </Content>
    </HomeContainer>
  );
};

export default Home; 